module.exports = __webpack_public_path__ + "img/freepass_use02.eb4b3bb5.png";